import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

// Stylesheets
import './styles/public.js';

console.log('App Version: ', process.env.VERSION);

ReactDOM.render(<App />, document.getElementById('root'));
